import {useLocation, useParams} from 'react-router-dom';
import LogoDark from '../../../app/assets/img/logo-dark.webp';
import {InfoSection, InfoSectionProps} from '../../../app/components/InfoSection';
import {ErrorCode} from '../../../app/types';
import {errorComponents} from '../errorComponents';
const defaultInfoSectionProps: InfoSectionProps = {
  icon: 'exclamation-circle',
  iconClassName: 'text-red-400',
  message: 'Unknown Error Occurred',
  title: 'Error',
};
export const Error = () => {
  const location = useLocation();
  const params = useParams<{
    statusCode?: string;
  }>();
  const errorCode = params?.statusCode ?? location.state?.statusCode;
  return (
    <div className="flex flex-col h-full">
      <div
        className="flex items-center text-white h-[4rem] px-4 py-1 shrink-0 shadow-lg"
        style={{
          background: '#052244',
        }}
      >
        <img alt="Biotandem" className="h-full" src={LogoDark} />
      </div>
      <div className="flex-1 flex items-center justify-center overflow-auto">{renderError()}</div>
    </div>
  );
  function renderError() {
    const Component = errorComponents[errorCode as ErrorCode] ?? InfoSection;
    return (
      <Component {...defaultInfoSectionProps} message={location.state?.message ?? defaultInfoSectionProps.message} />
    );
  }
};
